
 <div class="card originator-info" [ngClass]="{'selected': selected}">
  <div class="card-body d-flex flex-center flex-column pt-12 p-9">
    <div class="symbol symbol-50px symbol-circle mb-1">
      <img [src]="!originator.avatar || originator.avatar.includes('male.png') ? 'assets/media/avatars/blank.png' : originator.avatar" alt="image" />
    </div>
    <span class="fs-4 text-gray-800 text-hover-primary fw-bolder mb-0">{{originator.firstName + " " + originator.lastName}}</span>
  </div>
</div>
